<template>
  <div v-if="visible">
    <el-dialog
      title="打印绩效"
      v-loading="loading"
      :element-loading-text="loadingText"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(255, 255,255,0.7)"
      :close-on-click-modal="false"
      :visible.sync="visible"
      :before-close="dialogClose"
      width="850px"
    >
      <div style="z-index: 9999;position:fixed;margin-left:700px;margin-top:300px;">
        <div>
          <el-button type="primary" round @click="batchPrint" style="width:120px;">打印 / 保存PDF</el-button>
        </div>
        <div>
          <el-button
            type="danger"
            round
            @click="visible=false;"
            style="width:120px;margin-top:5px;"
          >关闭</el-button>
        </div>
      </div>

      <div id="printContent">
        <!-- 封面-->
        <div class="page" style="page-break-before:always;">
          <div>
            <div style="text-align:right;">编号：{{data.assessNo}}</div>
            <div style="margin-top:100px;text-align:center;" class="title">
              <h1>{{data.title}}</h1>
            </div>
            <div style="text-align:center;margin-top:80px;">
              <h2>登&nbsp;&nbsp;记&nbsp;&nbsp;表</h2>
            </div>
            <div style="text-align:center;margin-top:80px;font-size:14px;">
              <h3>（{{data.startYear}} - {{data.endYear}} 学年度）</h3>
            </div>
          </div>

          <div style="width:350px;margin:0 auto;font-size:20px;margin-top:380px;line-height:140%;">
            <div style="width:80px;float:left;">学校名称</div>
            <div style="float:left;">：</div>
            <div style="float:left;border-bottom:1px solid #000;width:230px;">{{data.schoolName}}</div>
            <div style="width:80px;float:left;">姓&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;名</div>
            <div style="float:left;">：</div>
            <div style="float:left;border-bottom:1px solid #000;width:230px;">{{data.assessUser}}</div>
            <div style="width:80px;float:left;">填表时间</div>
            <div style="float:left;">：</div>
            <div style="float:left;border-bottom:1px solid #000;width:230px;">{{data.gmtCreate}}</div>
          </div>
          <div style="width:100%;height:0px;clear:both;"></div>
          <div
            style="text-align:center;margin-top:150px;font-size:14px;float:none;"
          >{{data.companyName}}&nbsp;&nbsp;制</div>
        </div>
        <!-- 课程表-->
        <div class="page" style="page-break-before:always;" v-if="courseList.length>0">
          <el-divider></el-divider>
          <div style="margin-top:20px;text-align:center;">
            <h1>课程表（上）</h1>
          </div>
          <div style="margin:0 auto;width:600px;height:380px;border:1px solid black;">
            <div v-text="courseList[0].upCourse"></div>
            <div v-for="(item,index) of courseList[0].upCourseFile" :key="index">
              <div v-if="item.fileType == 1" style>
                <img :src="item.url" style="max-width:550px; max-height:350px" />
              </div>
              <div v-else>
                {{item.fileName}}
                <span style="color:red;font-size:12px;">(此附件无法打印，只能在系统查看)</span>
              </div>
            </div>
          </div>
          <div style="margin-top:10px;text-align:center;">
            <h1>课程表（下）</h1>
          </div>
          <div style="margin:0 auto;width:600px;height:380px;border:1px solid black;">
            <div v-text="courseList[0].downCourse"></div>
            <div v-for="(item,index) of courseList[0].downCourseFile" :key="index">
              <div v-if="item.fileType == 1" style>
                <img :src="item.url" style="max-width:550px; max-height:350px" />
              </div>
              <div v-else>
                {{item.fileName}}
                <span style="color:red;font-size:12px;">(此附件无法打印，只能在系统查看)</span>
              </div>
            </div>
          </div>
        </div>
        <!-- 填 表 说 明-->
        <div class="page" style="page-break-before:always;">
          <el-divider></el-divider>
          <div style="margin-top:100px;margin-bottom:100px;text-align:center;">
            <h1>填&nbsp;&nbsp;表&nbsp;&nbsp;说&nbsp;&nbsp;明</h1>
          </div>

          <div style="margin:0 auto;width:500px;font-size:16px;">
            <ul style="line-height:40px;list-style-type:none;">
              <li>1、绩效考核登记表由本人如实填写。字迹要端正、清楚。</li>
              <li>2、表内的年、月、日一律用公历和阿拉伯数字。</li>
              <li>3、未确定考核等次或不参加考核的，在“备注”栏中说明。</li>
              <li>4、不够填写，可另附纸张。</li>
              <li>5、此表一式填写二份，一份存入个人档案，一份存学校。</li>
              <li>6、将学校评定得分后的“绩效考核要点”附在考核表后存档。</li>
            </ul>
          </div>
        </div>
        <!-- 个人姓名表格-->
        <div class="page" style="page-break-before:always;">
          <el-divider></el-divider>
          <div style="margin:0 auto;width:95%;font-size:16px;text-align:center;margin-top:100px;">
            <table
              align="center"
              cellspacing="0"
              border="1"
              style="border-collapse: collapse;width:100%;"
            >
              <tr>
                <td style="width:80px;height:70px;">姓名</td>
                <td colspan="2" style="width:100px;"></td>
                <td style="width:80px;">性别</td>
                <td style="width:100px;"></td>
                <td style="width:80px;">出生年月</td>
                <td colspan="2"></td>
              </tr>

              <tr>
                <td style="width:80px;height:70px;">政治面貌</td>
                <td colspan="2"></td>
                <td colspan="2">现任党政职务</td>
                <td colspan="3"></td>
              </tr>

              <tr>
                <td style="width:80px;height:70px;">现任专业技术职务</td>
                <td colspan="2"></td>
                <td colspan="2">岗位等级</td>
                <td colspan="3"></td>
              </tr>

              <tr>
                <td rowspan="4" style="width:80px;height:70px;">教师工作量</td>
                <td>任教班级</td>
                <td>学生数</td>
                <td>学科</td>
                <td>每周任课节数</td>
                <td>本学年完成节数</td>
                <td colspan="2">其他教学活动</td>
              </tr>
              <tr>
                <td style="width:80px;height:70px;"></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td colspan="2"></td>
              </tr>
              <tr>
                <td style="width:80px;height:70px;"></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td colspan="2"></td>
              </tr>
              <tr>
                <td style="width:80px;height:70px;"></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td colspan="2"></td>
              </tr>

              <tr>
                <td style="width:80px;height:70px;" colspan="2">担任班主任班级</td>
                <td colspan="2"></td>
                <td colspan="2">学校其他管理工作</td>
                <td colspan="2"></td>
              </tr>

              <tr>
                <td style="width:80px;height:180px;">社会兼职或参加何学术团体任何职务</td>
                <td colspan="7"></td>
              </tr>

              <tr>
                <td style="width:80px;height:120px;">奖惩情况</td>
                <td colspan="7"></td>
              </tr>

              <tr>
                <td rowspan="3" style="width:80px;height:70px;">出勤情况</td>
                <td>病假</td>
                <td>事假</td>
                <td>旷课（工）</td>
                <td colspan="4">规定活动缺席情况</td>
              </tr>
              <tr>
                <td
                  style="width:80px;height:70px;text-align:right;padding-right:10px;"
                  rowspan="2"
                >天</td>
                <td
                  rowspan="2"
                  style="width:80px;height:60px;text-align:right;padding-right:10px;"
                >天</td>
                <td
                  rowspan="2"
                  style="width:80px;height:60px;text-align:right;padding-right:10px;"
                >天</td>
                <td>政治学习</td>
                <td>教研活动</td>
                <td>校年段会议</td>
                <td>其他集体活动</td>
              </tr>
              <tr>
                <td style="width:80px;height:70px;text-align:right;padding-right:10px;">节</td>
                <td style="text-align:right;padding-right:10px;">节</td>
                <td style="text-align:right;padding-right:10px;">节</td>
                <td style="text-align:right;padding-right:10px;">节</td>
              </tr>
            </table>
          </div>
        </div>

        <!-- 个人总结及自评表格-->
        <div class="page" style="page-break-before:always;">
          <el-divider></el-divider>
          <div style="margin:0 auto;width:95%;font-size:16px;text-align:center;margin-top:100px;">
            <table
              align="center"
              cellspacing="0"
              border="1"
              style="border-collapse: collapse;width:100%;"
            >
              <tr>
                <td style="width:30px;height:1000px;">个人总结及自评</td>
                <td style="text-align:left;padding-top:950px;">
                  &nbsp;&nbsp;自评：
                  <div style="margin-left:45px;border-bottom:1px solid #000;width:200px;"></div>
                </td>
              </tr>
            </table>
          </div>
        </div>

        <!-- 审批表格-->
        <div class="page" style="page-break-before:always;">
          <el-divider></el-divider>
          <div style="margin:0 auto;width:95%;font-size:16px;text-align:center;margin-top:100px;">
            <table
              align="center"
              cellspacing="0"
              border="1"
              style="border-collapse: collapse;width:100%;"
            >
              <tr>
                <td style="width:100px;height:200px;">民主测评情况</td>
                <td style="text-align:left;"></td>
              </tr>

              <tr>
                <td style="width:100px;height:200px;">学科组或年级组评议意见</td>
                <td style="text-align:left;"></td>
              </tr>

              <tr>
                <td style="width:100px;height:200px;">学校考核小组意见</td>
                <td style="text-align:right;padding-top:120px;">
                  <div style="margin-right:83px;">（公章）</div>
                  <div
                    style="margin-top:15px;margin-right:40px;"
                  >年&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;月&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;日</div>
                </td>
              </tr>

              <tr>
                <td style="width:100px;height:200px;">本人意见</td>
                <td style="text-align:right;padding-top:120px;">
                  <div style="margin-right:90px;">签名：</div>
                  <div
                    style="margin-top:15px;margin-right:40px;"
                  >年&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;月&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;日</div>
                </td>
              </tr>

              <tr>
                <td style="width:100px;height:200px;">备注</td>
                <td style="text-align:left;"></td>
              </tr>
            </table>
          </div>
        </div>

        <!-- 教师绩效-->
        <div class="page" style="page-break-before:always;">
          <el-divider></el-divider>
          <table
            border="1"
            style="border-collapse: collapse;width:100%;text-align:center;border-spacing:0;margin-top:50px;"
          >
            <thead style="display:table-header-group;font-weight:bold">
              <tr>
                <th colspan="2" style="width:100px;height:50px;">评价指标</th>
                <th rowspan="2" style="width:100px;">评价要素</th>
                <th rowspan="2" style="width:230px;">自我评诉</th>
                <th rowspan="2" style="width:60px;">自评得分</th>
                <th rowspan="2" style="width:80px;">学校评价</th>
                <th rowspan="2" style="width:60px;">学校得分</th>
                <th rowspan="2" style="width:80px;">学区评价</th>
                <th rowspan="2" style="width:60px;">学区得分</th>
              </tr>
              <tr>
                <th style="width:50px;">一级</th>
                <th style="width:50px;">二级</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item,index) of indexList" :key="index">
                <td
                  style="width:50px;"
                  v-html="item.indexOneLevelName"
                  :rowspan="item.indexOneLevelRowspan"
                  v-if="item.indexOneLevelName!=null"
                ></td>
                <td
                  style="width:50px;"
                  v-html="item.indexTwoLevelName"
                  :rowspan="item.indexTwoLevelRowspan"
                  v-if="item.indexTwoLevelName!=null"
                ></td>
                <td style="width:100px;">
                  <div v-html="item.evaluateAsk"></div>
                </td>
                <td
                  style="width:230px;word-break: break-all; word-wrap:break-word;text-align:left;"
                >
                  {{item.selfComment}}
                  <!-- 奖项-->
                  <div
                    v-for="(subItem,subIndex) of item.selfDefineScore"
                    :key="subIndex"
                    style="text-align:left;"
                  >{{subIndex+1}}、{{subItem}}</div>
                  <!-- 附件-->
                  <div
                    v-if="item.selfCommentFile.length>0"
                    style="text-align:left;font-weight:bold"
                  >
                    附件
                    <span style="font-size:12px;">(附件无法打印，只能在系统查看)</span>：
                  </div>
                  <div
                    v-for="(file,subIndex) of item.selfCommentFile"
                    :key="subIndex"
                    style="text-align:left;"
                  >{{subIndex+1}}、{{file.fileName}}</div>
                </td>
                <td>{{item.selfScore}}</td>
                <td>{{item.schoolComments}}</td>
                <td>{{item.schoolScore}}</td>
                <td>{{item.areaComments}}</td>
                <td>{{item.areaScore}}</td>
              </tr>
              <tr>
                <td colspan="3" style="width:100px;height:80px;">
                  <h2>合计</h2>评价总分（100分）
                </td>
                <td colspan="2">{{selfScore}}分</td>
                <td colspan="2">{{schoolScore}}分</td>
                <td colspan="2">{{areaScore}}分</td>
              </tr>
            </tbody>
          </table>

          <!-- 学校盖章 -->
          <div style="text-align:right;">
            <div style="margin-top:50px;margin-right:75px;">学校盖章</div>
            <div
              style="margin-top:15px;margin-right:40px;"
            >年&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;月&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;日</div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
       
<script>
import http from "../../../../common/http";
import print from "print-js";

export default {
  data() {
    return {
      loading: false,
      loadingText: "",

      visible: false,
      data: [],
      courseList: [],
      indexList: [],
      selfScore: 0,
      schoolScore: 0,
      areaScore: 0
    };
  },
  created: function() {},
  methods: {
    init(data) {
      this.visible = true;
      this.data = data;
      // 查询数据
      this.getData();
    },
    getData() {
      // console.log(JSON.stringify(this.data));
      this.loading = true;
      this.loadingText = "数据加载中...";

      let url = this.TeacherAssessIndexDataListUrl;
      let data = {
        id: this.data.id
      };

      this.apiPost(url, data).then(
        res => {
          if (res.status == 200) {
            // console.log(JSON.stringify(res.data.indexList));
            this.courseList = res.data.courseList;
            this.indexList = res.data.indexList;
            this.selfScore = res.data.selfScore;
            this.schoolScore = res.data.schoolScore;
            this.areaScore = res.data.areaScore;
          } else {
            this.$commonFn.showTip(res.message, 3);
          }
          this.loading = false;
        },
        err => {
          this.loading = false;
        }
      );
    },
    dialogClose(done) {
      done();
      this.$reload;
      this.visible = false;
    },
    batchPrint() {
      const style = "@page {margin:0 10mm};table {table-layout:fixed;}";
      // const style = "table {table-layout:fixed;}";
      printJS({
        printable: "printContent",
        type: "html",
        targetStyles: ["*"],
        scanStyles: false,
        style,
        ignoreElements: ["no-print", "bc", "gb"]
      });
    }
  },
  mixins: [http]
};
</script>

<style scoped>
.page {
  margin: 1cm auto;
  border-radius: 5px;
  background: white;
}
</style>


// WEBPACK FOOTER //
// src/components/page/teacherAssess/teacherAssess/PrintTeacherAssess.vue